import React from "react"
import { Card, CardBody } from "reactstrap"
import SimpleBar from "simplebar-react"
import { useTranslation } from "react-i18next"

const ConsumptionTimeLine = ({ data }: any) => {
  const { t } = useTranslation()

  return (
    <Card className="shadow-md rounded-3">
      <CardBody className="p-2">
        <p className="mb-0">
          <span className="text-muted text-12px">
            {t("coupons_consumptionTimeLine")}
          </span>
        </p>

        <SimpleBar className="mt-3">
          <ul className="verti-timeline list-unstyled">
            {data.map((item: any, index: number) => (
              <li className="event-list" key={index}>
                <div className="event-timeline-dot">
                  {item.couponState === "Coupon Used" ? (
                    <span
                      className="rounded-circle bg-primary d-flex align-items-center justify-content-center"
                      style={{
                        width: "20px",
                        height: "20px",
                      }}
                    >
                      <i className="bx bx-check text-white"></i>
                    </span>
                  ) : (
                    <span
                      className="rounded-circle bg-secondary d-flex align-items-center justify-content-center"
                      style={{
                        width: "10px",
                        height: "10px",
                        marginLeft: "3px",
                      }}
                    ></span>
                  )}
                </div>
                <div className="d-flex space-between">
                  <div className="flex-grow-1">
                    <div>
                      <b>{item.couponState}</b>
                      <p className="mb-0 text-muted">{item.date}</p>
                    </div>
                    <div>
                      <p className="mb-0 font-size-12 fw-medium">
                        {item.details}
                      </p>
                    </div>
                  </div>
                  <div>
                    <span className="badge p-1 bg-success-30 text-success mb-0 font-size-12 fw-medium">
                      {item.location} <i className="dripicons-location"></i>
                    </span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </SimpleBar>
      </CardBody>
    </Card>
  )
}

export default ConsumptionTimeLine
